import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { AppLayout } from './components/layout/AppLayout';
import { Carregando } from './components/ui/Estados';
import { useAuth } from './lib/auth/AuthContext';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ItensPage } from './pages/ItensPage';
import { ItemPage } from './pages/ItemPage';
import { MarcasPage } from './pages/MarcasPage';
import { ProdutosPage } from './pages/ProdutosPage';
import { ProdutoPage } from './pages/ProdutoPage';
import { LotesPage } from './pages/LotesPage';
import { SessoesPage } from './pages/SessoesPage';
import { AparelhosPage } from './pages/AparelhosPage';
import { MarcacaoEmMassaPage } from './pages/MarcacaoEmMassaPage';
import {
  AlertasPage,
  AncoragemPage,
  ContaPage,
  PessoasPage,
  UnidadesPage,
} from './pages/EmpresaPages';
import { CheckpointsPage } from './pages/CheckpointsPage';
import { LeiturasDeConsumidorPage } from './pages/LeiturasDeConsumidorPage';

/**
 * As rotas.
 *
 * <p>Tudo o que não é a entrada exige sessão. A guarda está <b>uma vez</b>, no elemento que
 * envolve a casca — repetida por rota, ela seria esquecida na próxima rota acrescentada, e
 * o sintoma seria uma tela que abre vazia em vez de mandar entrar.
 */
export function App() {
  return (
    <Routes>
      <Route path="/entrar" element={<LoginPage />} />
      <Route element={<ExigeSessao />}>
        <Route element={<AppLayout />}>
          <Route path="/indicadores" element={<DashboardPage />} />
          <Route path="/itens" element={<ItensPage />} />
          <Route path="/itens/:itemId" element={<ItemPage />} />
          <Route path="/sessoes" element={<SessoesPage />} />
          <Route path="/alertas" element={<AlertasPage />} />
          <Route path="/leituras-de-consumidor" element={<LeiturasDeConsumidorPage />} />
          <Route path="/marcacao-em-massa" element={<MarcacaoEmMassaPage />} />
          <Route path="/produtos" element={<ProdutosPage />} />
          <Route path="/produtos/:productId" element={<ProdutoPage />} />
          <Route path="/lotes" element={<LotesPage />} />
          <Route path="/marcas" element={<MarcasPage />} />
          <Route path="/checkpoints" element={<CheckpointsPage />} />
          <Route path="/unidades" element={<UnidadesPage />} />
          <Route path="/aparelhos" element={<AparelhosPage />} />
          <Route path="/pessoas" element={<PessoasPage />} />
          <Route path="/ancoragem" element={<AncoragemPage />} />
          <Route path="/conta" element={<ContaPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/itens" replace />} />
    </Routes>
  );
}

function ExigeSessao() {
  const { sessao, carregando } = useAuth();
  if (carregando) {
    return <Carregando />;
  }
  if (!sessao) {
    return <Navigate to="/entrar" replace />;
  }
  // O Outlet vem do AppLayout, que é a rota filha.
  return <Outlet />;
}
